import { useLayerRegistry } from '@/map/layers/registry';
import { ensureFeatureLayer, requireLayerRecord } from './shared/layers';
import type { Tool } from './types';

type Input = { layer_id: string; where: string | null };

export const layerSetFilter: Tool<Input> = {
  name: 'layer_set_filter',
  description:
    'Apply (or clear) a SQL definitionExpression on a feature layer. The layer redraws to show only matching features — different from `render(highlight)` which is an overlay. Pass `where: null` to clear. Use this when the user asks to "only show", "filter to", or "hide everything except".',
  input_schema: {
    type: 'object',
    properties: {
      layer_id: { type: 'string' },
      where: {
        oneOf: [{ type: 'string' }, { type: 'null' }],
        description: 'SQL WHERE clause, or null to clear the filter.',
      },
    },
    required: ['layer_id', 'where'],
    additionalProperties: false,
  },
  execute: async ({ layer_id, where }) => {
    const layer = await ensureFeatureLayer(layer_id);
    requireLayerRecord(layer_id);

    const expr = where == null ? '' : where.trim();
    layer.definitionExpression = expr;
    useLayerRegistry.getState().patch(layer_id, {
      definition_expression: expr || undefined,
    });

    return {
      ok: true,
      layer_id,
      where: expr || null,
    };
  },
};
